import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GlobalDodAgencyBasicInfoComponent from './global-dod-agency-basic-info';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';

export const GlobalDODAgencyComponent = ({id,selectedGlobalDODMapping,handleInnerFormChange,back,dodProgramParticipants,channelPrograms
 
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Basic Info',
      component: <GlobalDodAgencyBasicInfoComponent
      selectedGlobalDODMapping={selectedGlobalDODMapping}
      handleInnerFormChange={handleInnerFormChange}
        dodProgramParticipants={dodProgramParticipants}
        channelPrograms={channelPrograms}
        id={id}
      />,
      isVisible: true,
    },
  ]
 
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

<TabContainer tabItems={tabItems}/>

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        </div>
    </div>
  )
}
export default GlobalDODAgencyComponent;
